"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Chip = _interopRequireDefault(require("@material-ui/core/Chip"));

var _classnames = _interopRequireDefault(require("classnames"));

var _core = require("@material-ui/core");

var _reactDragAndDrop = require("react-drag-and-drop");

var _styles = require("./styles");

var Chip = function Chip(props) {
  var id = props.id,
      avatar = props.avatar,
      label = props.label,
      onDelete = props.onDelete,
      className = props.className,
      classes = props.classes,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["id", "avatar", "label", "onDelete", "className", "classes"]);
  return /*#__PURE__*/_react.default.createElement(_reactDragAndDrop.Draggable, {
    type: "label",
    className: classes.draggable,
    data: label
  }, /*#__PURE__*/_react.default.createElement(_Chip.default, (0, _extends2.default)({
    id: id,
    className: (0, _classnames.default)("prmbl-chip", className),
    classes: {
      root: classes.root,
      label: classes.label,
      deleteIcon: classes.deleteIcon,
      deletable: classes.deletable
    },
    avatar: avatar,
    label: label,
    onDelete: onDelete,
    deleteIcon: /*#__PURE__*/_react.default.createElement("svg", {
      height: "20",
      width: "20",
      viewBox: "0 0 20 20",
      "aria-hidden": "true",
      focusable: "false"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }))
  }, otherProps)));
};

Chip.propTypes = {
  /**
   * The html id
   */
  id: _propTypes.default.string,

  /**
   * Avatar element
   */
  avatar: _propTypes.default.element,

  /**
   * The contents of the chip label
   */
  label: _propTypes.default.node,

  /**
   * Callback function fired when the delete icon is clicked. If set, the delete icon will be shown.
   */
  onDelete: _propTypes.default.func,

  /**
   * @ignore
   *
   * Utilized By:
   * CivicEngage, CP Platform
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   *
   * Utilizing this to style up the page don't want to expose this in the style guide.
   * Auto-populated by material-ui withStyles()
   */
  classes: _propTypes.default.object.isRequired
};
Chip.defaultProps = {
  className: ""
};

var _default = (0, _core.withStyles)(_styles.styles)(Chip);

exports.default = _default;